import type { AllChatterTableType } from '@/modules/tracking/chatter-tracking/service/chatter-tracking-service'
import { getRandomNumber } from '@/utils/random'

// to avoid id conflicts
const MIN_ID = 1000000000
const MAX_ID = 9999999999

export const getEmptyTrackingData = (): AllChatterTableType => ({
  userId: getRandomNumber(MIN_ID, MAX_ID),
  name: 'Recently created user',
  minutesActive: 0,
  minutesInactive: 0,
  totalNetRevenue: 0,
  averageResponseTime: 0,
  sendMessages: 0,
  sentPPVs: 0,
  boughtPPVs: 0,
})
